'use client';

import { FactoringOnboardingLandingPromotionResponse } from '@trucksmarter/shared';
import { createContext, useContext, PropsWithChildren, useMemo } from 'react';

const FactoringOnboardingLandingPromotionDetailsContext =
  createContext<FactoringOnboardingLandingPromotionResponse | null>(null);

interface Props {
  factoringOnboardingLandingPromotionDetails: FactoringOnboardingLandingPromotionResponse;
}

export function useFactoringOnboardingLandingPromotionDetails() {
  const factoringOnboardingLandingPromotionDetails = useContext(
    FactoringOnboardingLandingPromotionDetailsContext,
  );
  return factoringOnboardingLandingPromotionDetails;
}

export default function FactoringOnboardingLandingPromotionDetailsProvider({
  factoringOnboardingLandingPromotionDetails,
  children,
}: PropsWithChildren<Props>) {
  // If ever using factoring onboarding promo details for anything other than display,
  // extract this into a util and utilize where needed.
  const factoringPromotionEndDateFormatted = useMemo(() => {
    if (!factoringOnboardingLandingPromotionDetails) {
      return '';
    }
    const dateArr =
      factoringOnboardingLandingPromotionDetails.promoEndDateInclusive.split(
        '-',
      );
    return `${parseInt(dateArr[1], 10)}/${parseInt(dateArr[2], 10)}/${
      dateArr[0]
    }`;
  }, [factoringOnboardingLandingPromotionDetails]);

  return (
    <FactoringOnboardingLandingPromotionDetailsContext.Provider
      value={
        factoringOnboardingLandingPromotionDetails
          ? {
              ...factoringOnboardingLandingPromotionDetails,
              promoEndDateInclusive: factoringPromotionEndDateFormatted,
            }
          : null
      }
    >
      {children}
    </FactoringOnboardingLandingPromotionDetailsContext.Provider>
  );
}
